(() => {
  const sections = document.querySelectorAll('[data-texan-product-reviews]');
  if (!sections.length) return;

  sections.forEach((section) => {
    initPagination(section);
    initSubmitForm(section);
  });

  function initPagination(section) {
    const totalPages = Number(section.dataset.reviewsTotalPages || 1);
    if (totalPages <= 1) return;

    const items = section.querySelectorAll('[data-review-page]');
    const prevButton = section.querySelector('[data-texan-reviews-prev]');
    const nextButton = section.querySelector('[data-texan-reviews-next]');
    const status = section.querySelector('[data-texan-reviews-status]');
    let currentPage = 1;

    const showPage = (page) => {
      currentPage = page;
      items.forEach((item) => {
        const itemPage = Number(item.getAttribute('data-review-page') || 1);
        item.classList.toggle('texan-product-reviews__item--hidden', itemPage !== currentPage);
      });
      if (status) status.textContent = `Page ${currentPage} of ${totalPages}`;
      if (prevButton) prevButton.disabled = currentPage <= 1;
      if (nextButton) nextButton.disabled = currentPage >= totalPages;
    };

    prevButton?.addEventListener('click', () => {
      if (currentPage > 1) showPage(currentPage - 1);
    });
    nextButton?.addEventListener('click', () => {
      if (currentPage < totalPages) showPage(currentPage + 1);
    });

    showPage(1);
  }

  function initSubmitForm(section) {
    const form = section.querySelector('[data-texan-review-form]');
    const message = section.querySelector('[data-texan-review-message]');
    const turnstileContainer = section.querySelector('[data-texan-turnstile]');
    if (!form) return;

    const submitUrl = section.dataset.submitUrl;
    const configUrl = section.dataset.submitConfigUrl;
    const button = form.querySelector('button[type="submit"]');
    let turnstileRequired = false;
    let turnstileToken = '';
    let turnstileWidgetId = null;

    const setSubmitEnabled = (enabled) => {
      if (button) button.disabled = !enabled;
    };

    const loadTurnstileScript = () =>
      new Promise((resolve, reject) => {
        if (window.turnstile) {
          resolve(window.turnstile);
          return;
        }
        const existing = document.querySelector('script[data-texan-turnstile-script]');
        if (existing) {
          existing.addEventListener('load', () => resolve(window.turnstile));
          existing.addEventListener('error', () => reject(new Error('Could not load human verification.')));
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.defer = true;
        script.dataset.texanTurnstileScript = 'true';
        script.onload = () => resolve(window.turnstile);
        script.onerror = () => reject(new Error('Could not load human verification.'));
        document.head.appendChild(script);
      });

    const initTurnstile = async () => {
      if (!configUrl || !turnstileContainer) return;

      try {
        const response = await fetch(configUrl, { method: 'GET' });
        const config = await response.json().catch(() => ({}));
        const siteKey = config.turnstile_site_key;
        turnstileRequired = Boolean(config.turnstile_required && siteKey);
        if (!turnstileRequired) return;

        const turnstile = await loadTurnstileScript();
        turnstileContainer.hidden = false;
        setSubmitEnabled(false);

        turnstileWidgetId = turnstile.render(turnstileContainer, {
          sitekey: siteKey,
          theme: 'light',
          callback: (token) => {
            turnstileToken = token;
            setSubmitEnabled(true);
          },
          'expired-callback': () => {
            turnstileToken = '';
            setSubmitEnabled(false);
          },
          'error-callback': () => {
            turnstileToken = '';
            setSubmitEnabled(false);
            showMessage(message, 'Human verification failed to load. Refresh and try again.', true);
          },
        });
      } catch (error) {
        if (turnstileRequired) {
          setSubmitEnabled(false);
          showMessage(message, error.message || 'Human verification is unavailable right now.', true);
        }
      }
    };

    initTurnstile();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const productId = section.dataset.productId;
      const productHandle = section.dataset.productHandle;
      if (!submitUrl || !productId) return;

      const formData = new FormData(form);
      const payload = {
        product_id: String(productId),
        product_handle: productHandle || null,
        rating: Number(formData.get('rating') || 5),
        body: String(formData.get('body') || '').trim(),
        author_name: String(formData.get('author_name') || '').trim(),
      };

      if (!payload.author_name || payload.author_name.length < 2) {
        showMessage(message, 'Please enter your name.', true);
        return;
      }

      if (!payload.body || payload.body.length < 12) {
        showMessage(message, 'Please write at least 12 characters about your experience.', true);
        return;
      }

      if (turnstileRequired && !turnstileToken) {
        showMessage(message, 'Please complete the human verification check.', true);
        return;
      }

      if (turnstileToken) {
        payload.turnstile_token = turnstileToken;
      }

      if (button) button.disabled = true;
      showMessage(message, 'Submitting…', false);

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.detail || data.message || 'Could not submit review.');
        }
        form.reset();
        turnstileToken = '';
        if (window.turnstile && turnstileWidgetId !== null) {
          window.turnstile.reset(turnstileWidgetId);
          if (turnstileRequired) setSubmitEnabled(false);
        }
        showMessage(
          message,
          data.message || 'Thanks! Your review was submitted.',
          false,
          'success'
        );
      } catch (error) {
        showMessage(message, error.message || 'Could not submit review.', true);
        if (window.turnstile && turnstileWidgetId !== null) {
          window.turnstile.reset(turnstileWidgetId);
          turnstileToken = '';
          if (turnstileRequired) setSubmitEnabled(false);
        }
      } finally {
        if (button && (!turnstileRequired || turnstileToken)) {
          button.disabled = false;
        }
      }
    });
  }

  function showMessage(node, text, isError, tone) {
    if (!node) return;
    node.hidden = false;
    node.textContent = text;
    node.classList.toggle('texan-product-reviews__message--error', Boolean(isError));
    node.classList.toggle('texan-product-reviews__message--success', !isError && tone === 'success');
  }
})();
